import {useRef, useEffect, useState} from 'react';
import {convertTzDate, showToast, useInterval, getMapStyle} from '../common/app_common.js';
import {Title, LoadingSpinner} from '../common/component_common.js';
import {getApiConfigSystem} from '../common/fetch_api/configuration.js'
import {getApiReceiveEdgeDataQuery} from '../common/fetch_api/coverage.js'
import {getApiMapboxTokenCheck} from '../common/fetch_api/api_common.js'
import 'mapbox-gl/dist/mapbox-gl.css';
import '../common/css/coverage.css'
import Button from 'react-bootstrap/Button';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { SearchCanvas, MobileCanvas } from './coverage/offcanvas.js';

const clusterSourceId = ['good-cluster-source', 'normal-cluster-source', 'bad-cluster-source'];
const clusterLayerId = ['good-cluster-layer', 'normal-cluster-layer', 'bad-cluster-layer'];
const clusterCountId = ['good-count-layer', 'normal-count-layer', 'bad-count-layer'];
const unclusterId = ['good-unclustered-layer', 'normal-unclustered-layer', 'bad-unclustered-layer'];

const TopReceiveStatusSection = ({edgesSeveriry, selectSeverity, selectMode, showCanvas, receiveMode, setReceiveMode}) =>
{
    const getSeverity = (status) =>
    {
        selectSeverity(status)
    }

    const [selectTitle, setSelectTitle] = useState('Total Receive Edge');

    const onChangeReceiveMode = (e) => {
        setReceiveMode(e.target.value);
        selectMode(e.target.value);
    }
    
    return (
        <>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
                {receiveMode==='fixed' && <TopReceiveStatusUnit selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Total Receive Edge'} status={'text-good'} value={edgesSeveriry.good.length + edgesSeveriry.normal.length + edgesSeveriry.bad.length} severity='' getSeverity={getSeverity}/>}
            </div>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
                {receiveMode==='fixed' && <TopReceiveStatusUnit selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Good'} status={'text-good'} value={edgesSeveriry.good.length} severity='good' getSeverity={getSeverity}/>}
            </div>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
                {receiveMode==='fixed' && <TopReceiveStatusUnit selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Normal'} status={'text-warning'} value={edgesSeveriry.normal.length} severity='normal' getSeverity={getSeverity}/>}
            </div>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
                {receiveMode==='fixed' && <TopReceiveStatusUnit selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Bad'} status={'text-critical'} value={edgesSeveriry.bad.length} severity='bad' getSeverity={getSeverity}/>            }
            </div>
            <div className="col-xxl-4 col-xl-2 col-lg-4 col-md-4 col-sm-12 col-12 receive-spacer"></div>
            <div className="col-xxl col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6">
                <div className="section receive-mode-area d-flex flex-column">
                    <div className="d-flex mode-select">
                        <div className="status-title">Mode</div>
                        <select className="form-select form-select-sm" onChange={onChangeReceiveMode} value={receiveMode}>
                            <option value="fixed">Fixed</option>
                            <option value="mobile">Mobile</option>
                        </select>
                    </div>
                    <Button variant='primary' className="btn btn-sm" onClick={showCanvas}>Edges</Button>
                </div>
            </div>
        </>
    )
}

const TopReceiveStatusUnit = ({selectTitle, setSelectTitle , title, status, value, severity, getSeverity}) => {

    const onClickSeverity = () =>
    {
        if( selectTitle !== title )
        {
            getSeverity(severity);
            setSelectTitle(title);
        }
    }

    return (
        <div className={`section status severity d-flex flex-column ${selectTitle === title ? 'active' : ''}`}  onClick={onClickSeverity}>
            <div className="status-title">{title}</div>
            <div className={`status-value ${status}`}>{value}</div>
        </div>
    )
}

const PageCoverage = () => {

    const [update, setUpdate] = useState(false);

    const mapContainer = useRef(null);
    const maruMap = useRef(null);
    const mapDefaultRef = useRef({lat:0, lng:0, zoom: 4});
    const mapInfoRef = useRef({lat:0, lng:0, zoom: 4});
    const [allEdgeData, setAllEdgeData] = useState([]);
    const [mapConfig, setMapConfig] = useState({lat:0, lng:0, zoom: 4});
    const curPopup = useRef(null);
    const [isDraw, setIsDraw] = useState(false);
    const clickInfo = useRef({locList: [], mode: 'fixed'})
    const showEdgeRef = useRef({flag:false, level:5.0});

    const [loading, setLoading] = useState(false);
    
    const isClick = useRef(false);
    const [alertStatus, setAlertStatus] = useState({good: [], normal: [], bad: []});
    const [filterSeverity, setFilterSeverity] = useState('');
    const [receiveMode, setReceiveMode] = useState('fixed');

    const [searchCanvas, setSearchCanvas] = useState(false);
    const showSearchCanvas = () => {
        setSearchCanvas(true);
    };
    const cloaseSearchCanvas = () => setSearchCanvas(false);

    const curEdgeId = useRef('');
    const drawEdgeId = useRef('');
    const [mobileCanvas, setMobileCanvas] = useState(false);
    const showMobileCanvas = (id) => {
        curEdgeId.current = id;
        setMobileCanvas(true);
    };
    const cloaseMobileCanvas = () => setMobileCanvas(false);

    function moveDefault()
    {
        maruMap.current.jumpTo({center: [mapDefaultRef.current.lng, mapDefaultRef.current.lat], zoom: mapDefaultRef.current.zoom});
    }

    function initMapSetting(systemInfo)
    {
        if( !systemInfo )
        {
            systemInfo = {
                "systemName": '',
                "map": {
                    "latitude": 36.3372,
                    "longitude": 127.3227,
                    "zoom": 16,
                    "style": 'Navigation_Night',
                    "locationOffset": 0
                },
                "serverStatusAlert": {
                    "diskUsagePercent": 0
                },
                "bugReport": false
            };
        }

        let temp = {lat: parseFloat(systemInfo.map.latitude), lng: parseFloat(systemInfo.map.longitude), zoom: parseFloat(systemInfo.map.zoom)};

        mapInfoRef.current = {lat: temp.lat, lng: temp.lng, zoom: temp.zoom.toFixed(2)};
        mapDefaultRef.current = mapInfoRef.current;
        setMapConfig(mapInfoRef.current);

        maruMap.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: getMapStyle(systemInfo.map.style),
            center: [temp.lng, temp.lat],
            zoom: temp.zoom,
        });
        maruMap.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    }

    function createClusters(sourceData, status)
    {
        maruMap.current.addSource(clusterSourceId[status], {
            type: 'geojson',
            data: sourceData,
            cluster: true,
            clusterMaxZoom: showEdgeRef.current.level - 1.0, // Max zoom to cluster points on
            clusterRadius: 100, // Radius of each cluster when clustering points (defaults to 50)
            // clusterProperties: {
            //     // keep separate counts for each magnitude category in a cluster
            //     'good': ['+', ['case', ['==', ['get', 'status'], 'good'], 1, 0]],
            //     'normal': ['+', ['case', ['==', ['get', 'status'], 'normal'], 1, 0]],
            //     'bad': ['+', ['case', ['==', ['get', 'status'], 'bad'], 1, 0]],
            // }
        });

        let color = '#ff5b5c';
        if(status === 0)
        {
            color = '#39da8a';
        }
        else if(status === 1)
        {
            color = '#fdac41';
        }
        
        maruMap.current.addLayer({
            id: clusterLayerId[status],
            type: 'circle',
            source: clusterSourceId[status],
            filter: ['has', 'point_count'],
            paint: {
                'circle-opacity': 0.7,
                'circle-color': color,
                // [
                    // 'case',
                    // ['all', ['==', ['get', 'bad'], 0], ['==', ['get', 'normal'], 0]], "#39da8a",
                    // ['all', ['==', ['get', 'bad'], 0], ['>=', ['get', 'normal'], 1]], "#fdac41",
                    // ['>=', ['get', 'bad'], 1], "#ff5b5c",
                    // '#707070',
                // ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    20, 30,
                    30, 40
                ]
            }
        });
        
        maruMap.current.addLayer({
            id: clusterCountId[status],
            type: 'symbol',
            source: clusterSourceId[status],
            filter: ['has', 'point_count'],
            layout: {
                'text-field': ['get', 'point_count_abbreviated'],
                'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                'text-size': [
                    'step',
                    ['get', 'point_count'],
                    12,
                    20, 20,
                    30, 30
                ]
            }
        });
        
        maruMap.current.addLayer({
            id: unclusterId[status],
            type: 'circle',
            source: clusterSourceId[status],
            filter: ['!', ['has', 'point_count']],
            paint: {
                'circle-color': color,
                // [
                //     'match',
                //     ['get', 'status'],
                //     'normal', '#fdac41',
                //     'bad', '#ff5b5c',
                //     /* good */ '#39da8a'
                // ],
                'circle-radius': 4,
                'circle-stroke-width': 1,
                'circle-stroke-color': '#fff',
            }
        });
    }

    function createReceiveInfo()
    {
        Promise.resolve( getApiReceiveEdgeDataQuery('') )
        .then( receiveData => {
            console.log('receiveData', receiveData)
            let sortData = [];

            for( const data of receiveData )
            {
                if( !sortData[data.id] )
                {
                    sortData[data.id] = [];
                    sortData[data.id].id = data.id;
                }

                sortData[data.id][data.field] = {date: data.value[0][0], value: data.value[0][1]};
            }

            return sortData;
        })
        .then( sortData => {
            setAllEdgeData(sortData);
        })
        .catch( e => {
            setLoading(false);
        });
    }

    function updateEdgeInfo()
    {
        removeSources();

        let goodSource = {
            type: 'FeatureCollection',
            features : []
        };

        let normalSource = {
            type: 'FeatureCollection',
            features : []
        };

        let badSource = {
            type: 'FeatureCollection',
            features : []
        };

        let goodArr = [];
        let normalArr = [];
        let badArr = [];

        for( const key of Object.keys(allEdgeData) )
        {
            const item = allEdgeData[key];

            if( item.lock.value === 1 )
            // if(1)
            {
                if( item.rssi )
                {
                    if( item.rssi.value > -50)
                    {
                        goodArr.push(item);
                        if( filterSeverity === 'good' || filterSeverity === '' )
                        {
                            goodSource.features.push({
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: [
                                        item.longitude.value,
                                        item.latitude.value
                                    ]
                                },
                                properties: {
                                    'id': key
                                },
                            });
                        }
                    }
                    else if( item.rssi.value > -70)
                    {
                        normalArr.push(item);
                        if( filterSeverity === 'normal' || filterSeverity === '' )
                        {
                            normalSource.features.push({
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: [
                                        item.longitude.value,
                                        item.latitude.value
                                    ]
                                },
                                properties: {
                                    'id': key
                                },
                            });
                        }
                    }
                    else
                    {
                        badArr.push(item);
                        if( filterSeverity === 'bad' || filterSeverity === '' )
                        {
                            badSource.features.push({
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: [
                                        item.longitude.value,
                                        item.latitude.value
                                    ]
                                },
                                properties: {
                                    'id': key
                                },
                            });
                        }
                    }
                }
            }
            else
            {
                badArr.push(item);
                if( filterSeverity === 'bad' || filterSeverity === '' )
                {
                    badSource.features.push({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [
                                item.longitude.value,
                                item.latitude.value
                            ]
                        },
                        properties: {
                            'id': key
                        },
                    });
                }
            }
        }
        
        createClusters(goodSource, 0);
        createClusters(normalSource, 1);
        createClusters(badSource, 2);

        setAlertStatus({good: goodArr, normal: normalArr, bad: badArr});

        setLoading(false);
    }

    useEffect(() => {
        if (!maruMap.current) // initialize map only once
        {
            Promise.resolve( getApiConfigSystem() )
            .then( systemInfo => {
                if( !systemInfo.map.mapboxToken )
                {
                    showToast('Invalid Map Token', 'error');
                    return;
                }

                Promise.resolve( getApiMapboxTokenCheck(systemInfo.map.mapboxToken) )
                .then( data => {
                    if( data && data.code )
                    {
                        if( data.code === 'TokenValid')
                        {
                            mapboxgl.accessToken = systemInfo.map.mapboxToken;
                            initMapSetting(systemInfo);
                        }
                        else
                        {
                            showToast(data.code, 'error');
                        }
                    }
                    else
                    {
                        showToast('Map Token Validation Failed', 'error');
                    }
                })
                .catch( e => {
                    showToast('Map Token Validation Failed', 'error');
                });
            });
        }
    }, []);
    
    const selectSiteSeverity = (status) =>
    {
        setFilterSeverity(status);
    }

    const selectMode = (mode) => {
        setReceiveMode(mode);
        clickInfo.current.mode = mode;
    }

    const searchResult = (info) => {
        if( receiveMode === 'fixed')
        {
            showPopupInfoFixed(info.id, info.coordinates)
            maruMap.current.flyTo({center: info.coordinates, zoom: showEdgeRef.current.level});
        }
        else
        {
            showMobileCanvas(info.id);
        }
    }

    const mobileDrawResult = (draw) => {
        drawEdgeId.current = draw.id;
        
        removeSources();
        
        let goodSource = {
            type: 'FeatureCollection',
            features : []
        };

        let normalSource = {
            type: 'FeatureCollection',
            features : []
        };

        let badSource = {
            type: 'FeatureCollection',
            features : []
        };

        let index = -1;

        for( const item of draw.data )
        {
            index++;

            if( item.lock.value === 1 )
            // if(1)
            {
                if( item.rssi )
                {
                    if( item.rssi > -50)
                    {
                        goodSource.features.push({
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    item.longitude,
                                    item.latitude
                                ]
                            },
                            properties: {
                                'description': JSON.stringify(item),
                                'index': index
                            },
                        });
                    }
                    else if( item.rssi > -70)
                    {
                        normalSource.features.push({
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    item.longitude,
                                    item.latitude
                                ]
                            },
                            properties: {
                                'description': JSON.stringify(item),
                                'index': index
                            },
                        });
                    }
                    else
                    {
                        badSource.features.push({
                            type: 'Feature',
                            geometry: {
                                type: 'Point',
                                coordinates: [
                                    item.longitude,
                                    item.latitude
                                ]
                            },
                            properties: {
                                'description': JSON.stringify(item),
                                'index': index
                            },
                        });
                    }
                }
            }
            else
            {
                badSource.features.push({
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            item.longitude,
                            item.latitude
                        ]
                    },
                    properties: {
                        'description': JSON.stringify(item),
                        'index': index
                    },
                });
            }
        }

        createClusters(goodSource, 0);
        createClusters(normalSource, 1);
        createClusters(badSource, 2);

        setIsDraw(true);
        setLoading(false);
    }

    const mobileInfoResult = (coordinates, idx) => {
        const goodSource = maruMap.current.getSource(clusterSourceId[0]);
        let description = '';

        for( const source of Array.from(goodSource._data.features) )
        {
            if( source.geometry.coordinates.toString() === coordinates.toString() && source.properties.index === idx )
            {
                description = source.properties.description;
                break;
            }
        }

        if(description === '')
        {
            const normalSource = maruMap.current.getSource(clusterSourceId[1]);
    
            for( const source of Array.from(normalSource._data.features) )
            {
                if( source.geometry.coordinates.toString() === coordinates.toString() && source.properties.index === idx )
                {
                    description = source.properties.description;
                    break;
                }
            }
        }

        if(description === '')
        {
            const badSource = maruMap.current.getSource(clusterSourceId[2]);
    
            for( const source of Array.from(badSource._data.features) )
            {
                if( source.geometry.coordinates.toString() === coordinates.toString() && source.properties.index === idx )
                {
                    description = source.properties.description;
                    break;
                }
            }
        }

        if(description !== '')
        {
            showPopupInfoMobile(description, coordinates);
            maruMap.current.flyTo({center: coordinates, zoom: showEdgeRef.current.level});
        }
    }

    useEffect(() => {
        if (!maruMap.current) return; // wait for map to initialize
        maruMap.current.on('move', () => {
            let tempZoom = maruMap.current.getZoom().toFixed(2);
            
            if( showEdgeRef.current.flag && tempZoom < showEdgeRef.current.level )
            {
                showEdgeRef.current.flag = false;
            }
            else if( !showEdgeRef.current.flag && tempZoom >= showEdgeRef.current.level )
            {
                showEdgeRef.current.flag = true;
            }

            mapInfoRef.current = {...mapInfoRef.current, lng:maruMap.current.getCenter().lng, lat:maruMap.current.getCenter().lat, zoom:tempZoom};
            setMapConfig(mapInfoRef.current);
        });
        
        maruMap.current.on('click', clusterLayerId[0], (e) => {
            const features = maruMap.current.queryRenderedFeatures(e.point, {
                layers: [clusterLayerId[0]]
            });

            const clusterId = features[0].properties.cluster_id;
            maruMap.current.getSource(clusterSourceId[0]).getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return;
                    
                    maruMap.current.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    });
                }
            );
        });
        
        maruMap.current.on('click', clusterLayerId[1], (e) => {
            const features = maruMap.current.queryRenderedFeatures(e.point, {
                layers: [clusterLayerId[1]]
            });

            const clusterId = features[0].properties.cluster_id;
            maruMap.current.getSource(clusterSourceId[1]).getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return;
                    
                    maruMap.current.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    });
                }
            );
        });
        
        maruMap.current.on('click', clusterLayerId[2], (e) => {
            const features = maruMap.current.queryRenderedFeatures(e.point, {
                layers: [clusterLayerId[2]]
            });

            const clusterId = features[0].properties.cluster_id;
            maruMap.current.getSource(clusterSourceId[2]).getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return;
                    
                    maruMap.current.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    });
                }
            );
        });

        maruMap.current.on('click', [...unclusterId], (e) => {

            if( isClick.current ) return;
            isClick.current = true;

            const coordinates = e.features[0].geometry.coordinates.slice();
            
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            
            if( clickInfo.current.mode === 'fixed' )
            {
                showPopupInfoFixed(e.features[0].properties.id, coordinates);
            }
            else
            {
                showPopupInfoMobile(e.features[0].properties.description, coordinates);
            }
                
            setTimeout(() => {
                isClick.current = false;
            }, 200);
        });
        
        maruMap.current.on('mouseenter', [...unclusterId, ...clusterLayerId], () => {
            maruMap.current.getCanvas().style.cursor = 'pointer';
        });
        
        maruMap.current.on('mouseleave', [...unclusterId, ...clusterLayerId], () => {
            maruMap.current.getCanvas().style.cursor = '';
        });
    });

    function showPopupInfoFixed(id, coordinates)
    {
        removeInfoWindow();

        Promise.resolve( getApiReceiveEdgeDataQuery(id) )
        .then( receiveData => {
            curPopup.current =
                new mapboxgl.Popup({ closeOnClick: true })
                .addClassName('receive-edge-map')
                .setLngLat(coordinates)
                .setHTML(fixedInfoWindow(receiveData))
                .addTo(maruMap.current);
        })
        .then( done => {
        });
    }

    function showPopupInfoMobile(sourceData, coordinates)
    {
        removeInfoWindow();

        curPopup.current =
            new mapboxgl.Popup({ closeOnClick: true })
            .addClassName('receive-edge-map')
            .setLngLat(coordinates)
            .setHTML(mobileInfoWindow(JSON.parse(sourceData)))
            .addTo(maruMap.current);
        
        const btn = document.getElementById("infoBtn");
        btn.addEventListener("click", () => {
            showMobileCanvas(drawEdgeId.current);
        });
    }

    function fixedInfoWindow(data)
    {
        if( data.length < 1 )
        {
            return `<div> </div>`;
        }
        
        let result = `<div class='mt-2'>${data[0].id}<div>`;

        for( const item of data )
        {
            if( item.field !== 'longitude' && item.field !== 'latitude' )
            {
                result += `<div>${item.field.toUpperCase()} : ${item.value[0][1]}<div>`;
            }
        }
        
        return `<div> ${result} </div>`;
    }

    function mobileInfoWindow(source)
    {
        let result = `<div class='mt-2'>${convertTzDate(source.date)}<div>`;

        result += `<div> FREQ : ${source.freq}<div>`;
        result += `<div> PLP : ${source.plp}<div>`;
        result += `<div> LOCK : ${source.lock}<div>`;
        result += `<div> SPEED : ${source.speed}<div>`;
        result += `<div> RSSI : ${source.rssi}<div>`;
        result += `<div> SNR : ${source.snr}<div>`;
        result += `<div> MER : ${source.mer}<div>`;
        result += `<div> FER : ${source.fer}<div>`;

        result += `<button id='infoBtn' class="btn btn-primary btn-sm"> Infomation </button>`;
        
        return `<div> ${result} </div>`;
    }

    function removeInfoWindow()
    {
        if( curPopup.current )
        {
            curPopup.current.remove();
        }
    }

    function removeSources()
    {
        removeInfoWindow();

        if( maruMap.current )
        {
            for( const id of clusterCountId)
            {
                if( maruMap.current.getLayer(id) )
                {
                    maruMap.current.removeLayer(id);
                }
            }
            
            for( const id of unclusterId)
            {
                if( maruMap.current.getLayer(id) )
                {
                    maruMap.current.removeLayer(id);
                }
            }
    
            for( const id of clusterLayerId)
            {
                if( maruMap.current.getLayer(id) )
                {
                    maruMap.current.removeLayer(id);
                }
            }
    
            for( const id of clusterSourceId)
            {
                if( maruMap.current.getSource(id) )
                {
                    maruMap.current.removeSource(id);
                }
            }
        }
    }

    function runUpdate()
    {
        setUpdate(!update);
    }

    useEffect( () => {
        if( maruMap.current && allEdgeData && receiveMode === 'fixed' )
        {
            updateEdgeInfo();
        }
    }, [allEdgeData]);

    const intvId = useRef(-1);
    useEffect(() => {
        
        intvId.current = setInterval(() => {
            if (!maruMap.current) return; // wait for map to initialize
            if( !maruMap.current.isStyleLoaded() ) return;

            setLoading(true);

            removeSources();

            clearInterval(intvId.current);

            if( receiveMode === 'mobile' )
            {
                showSearchCanvas();
            }

            createReceiveInfo();
            moveDefault();
        }, 500);
        
        setIsDraw(false);

    }, [update, receiveMode]);

    useEffect( () => {
        if( maruMap.current )
        {
            setLoading(true);
            removeInfoWindow();
            updateEdgeInfo();
        }
    }, [filterSeverity]);

    // useInterval(() =>
    // {
    //     runUpdate();
    // }, 300000 );
    
    return (
        <>
            <Title title='Coverage'></Title>
            <div className="d-flex flex-column mt-2 position-relative">
                <div className="d-flex flex-wrap top-status-area">
                    <TopReceiveStatusSection edgesSeveriry={alertStatus} selectSeverity={selectSiteSeverity} selectMode={selectMode} showCanvas={showSearchCanvas} receiveMode={receiveMode} setReceiveMode={setReceiveMode}/>
                </div>
                <div className="d-flex">
                    <div className="section col sub-map" ref={mapContainer} >
                        <div className={`pointer location-bar ${showEdgeRef.current.flag?'bg-label-success':''}`} onClick={moveDefault}>
                            Lng: {mapInfoRef.current.lng} | Lat: {mapInfoRef.current.lat} | Zoom: {mapInfoRef.current.zoom}
                        </div>
                    </div>
                </div>
            </div>
            {searchCanvas&&<SearchCanvas result={searchResult} edgeArr={alertStatus} severity={filterSeverity} mode={receiveMode} loading={setLoading} show={searchCanvas} handleClose={cloaseSearchCanvas}></SearchCanvas>}
            <MobileCanvas drawResult={mobileDrawResult} infoResult={mobileInfoResult} move={showSearchCanvas} curEdgeId={curEdgeId.current} loading={setLoading} show={mobileCanvas} handleClose={cloaseMobileCanvas}></MobileCanvas>
            <LoadingSpinner loading={loading}/>
        </>
    )
}

export default PageCoverage;